/**
 * PHARMAKON — BETA handlers registry
 *
 * Each ./{domain}.js file exports a `register(route)` function. This module
 * calls every register() to wire the full URL → handler map. New handlers
 * only need an import here.
 */
import { register as registerAuth } from "./auth.js";
import { register as registerProduits } from "./produits.js";
import { register as registerFournisseurs } from "./fournisseurs.js";
import { register as registerClients } from "./clients.js";
import { register as registerAchats } from "./achats.js";
import { register as registerVentes } from "./ventes.js";
import { register as registerCaisses } from "./caisses.js";
import { register as registerAvoirs } from "./avoirs.js";
import { register as registerInstances } from "./instances.js";
import { register as registerEfactures } from "./efactures.js";
import { register as registerDashboard } from "./dashboard.js";
import { register as registerAudit } from "./audit.js";
import { register as registerNotifications } from "./notifications.js";
import { register as registerPharmacie } from "./pharmacie.js";
import { register as registerUsers } from "./users.js";
import { register as registerStock } from "./stock.js";
import { register as registerRapports } from "./rapports.js";
import { register as registerDecision } from "./decision.js";
import { register as registerChifa } from "./chifa.js";
import { register as registerNomenclature } from "./nomenclature.js";
import { register as registerOcr } from "./ocr.js";
import { register as registerEmplacements } from "./emplacements.js";
import { register as registerPrint } from "./print.js";
import { register as registerAbonnement } from "./abonnement.js";
import { register as registerPortail } from "./portail.js";
import { register as registerAdmin } from "./admin.js";
import { register as registerMisc } from "./misc.js";

export function registerAll(route) {
  registerAuth(route);
  registerProduits(route);
  registerFournisseurs(route);
  registerClients(route);
  registerAchats(route);
  registerVentes(route);
  registerCaisses(route);
  registerAvoirs(route);
  registerInstances(route);
  registerEfactures(route);
  registerDashboard(route);
  registerAudit(route);
  registerNotifications(route);
  registerPharmacie(route);
  registerUsers(route);
  registerStock(route);
  registerRapports(route);
  registerDecision(route);
  registerChifa(route);
  registerNomenclature(route);
  registerOcr(route);
  registerEmplacements(route);
  registerPrint(route);
  registerAbonnement(route);
  registerPortail(route);
  registerAdmin(route);
  // misc must be last so domain-specific routes win when patterns overlap
  registerMisc(route);
}
